import { InfoOutlined } from '@mui/icons-material'
import { Box, Chip, SxProps, Theme, Tooltip, Typography } from '@mui/material'

import { FC } from 'react'
import { getSoftChipSx } from './chipStyles'

export interface ReadOnlyItemProps {
  /**
   * The class applied to the root element.
   */
  className?: string
  /**
   * The label of the item.
   */
  label: string
  /**
   * If `true`, the value can be shown in multiple lines.
   */
  multiline?: boolean
  /**
   * The value of the item.
   */
  value: string
  /**
   * The text to be displayed in the tooltip. If left empty or undefined, the info icon will not be displayed.
   */
  tooltip?: string

  sx?: SxProps<Theme>

  size?: 'medium' | 'small'

  chipColor?: string

  emphasis?: boolean
}

export const ReadOnlyChip: FC<ReadOnlyItemProps> = ({
  className,
  label,
  value,
  tooltip,
  multiline,
  sx,
  size,
  chipColor,
  emphasis = false,
}) => {
  return (
    <Box className={className} sx={sx}>
      <Box display="flex" alignItems="center" sx={{ marginBottom: 0.6 }}>
        <Typography
          variant={size === 'small' ? 'caption' : 'body2'}
          color="textSecondary"
          sx={{
            fontSize: size === 'small' ? 10.5 : 11.5,
            fontWeight: 500,
            lineHeight: 1.2,
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            textDecoration: 'none',
          }}
        >
          {label}
        </Typography>
        {tooltip && (
          <Tooltip title={tooltip} placement="right">
            <InfoOutlined color="primary" sx={{ marginLeft: 1, width: 13, height: 13 }} />
          </Tooltip>
        )}
      </Box>
      <Chip
        sx={{
          ...getSoftChipSx(chipColor, {
            height: size === 'small' ? 24 : 26,
            fontSize: size === 'small' ? 11 : 11.5,
            labelWeight: 500,
            emphasis,
          }),
          whiteSpace: multiline ? 'pre-wrap' : 'nowrap',
          textOverflow: 'ellipsis',
          overflow: 'hidden',
        }}
        label={value}
      />
    </Box>
  )
}
